import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectMultiComponent } from './select-multi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { PipeModule } from 'src/app/shared/pipe.module';

@NgModule({
  declarations: [SelectMultiComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiSelectModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    MenuModule,
    PipeModule,
  ],
  exports: [SelectMultiComponent],
})
export class SelectMultiModule {}
